// experiments.mjs

import { EXPERIMENTS } from './settings.mjs';

import { LongerPeriodsExperiment } from './experiments/longer-periods.mjs';
import { DoubleDurationExperiment } from './experiments/double-duration.mjs';
import { DoubleDurationAllExperiment } from './experiments/double-duration-all.mjs';
import { ChartRadiusExperiment } from './experiments/chart-radius.mjs';
import { ChartColorsExperiment } from './experiments/chart-colors.mjs'
import { SpecialExperiment } from './experiments/special.mjs';

// Central liste over alle tilgængelige eksperimentelle moduler i systemet
/** @type {ExperimentDefinition[]} */
const AVAILABLE_EXPERIMENTS = [
  LongerPeriodsExperiment,
  DoubleDurationExperiment,
  DoubleDurationAllExperiment,
  SpecialExperiment,
  ChartRadiusExperiment,
  ChartColorsExperiment
];

export const Experiments = {
  /**
   * Returnerer en liste over de eksperimenter, der skal aktiveres ved opstart
   * @returns {string[]}
   */
  getEnabledExperiments() {
    // 1. Hent browserens aktuelle URL-parametre
    const urlParams = new URLSearchParams(window.location.search);
    
    // 2. Læs værdien fra 'x' parameteren (f.eks. "?x=longer-periods&x=another-feature")
    const experimentsParam = urlParams.getAll('x'); // Returnerer streng eller null

    // 3. Tilføj hardcode experimenter først
    if (EXPERIMENTS) {
      experimentsParam.unshift(...EXPERIMENTS);
    }
    
    if (!experimentsParam) {
      return []; // Ingen eksperimenter aktiveret
    }

    return experimentsParam
  },

  /**
   * Injicerer eksperimenter, hvor et 'exclusive: true' modul blokerer 
   * alle andre moduler inden for samme kategori.
   * @param {AppState} appState 
   * @param {string[]} enabledExperimentIds
   * @returns {void}
   */
  injectExperiments(appState, enabledExperimentIds = []) {
    // 1. Map URL-ID'er til de faktiske eksperiment-objekter
    const requestedExperiments = enabledExperimentIds
      .map(rawId => {
        // Splitter f.eks. "chart-radius:full" til id = "chart-radius" og args = ["full"]
        const [id, ...args] = rawId.split(':');
        
        const experiment = AVAILABLE_EXPERIMENTS.find(e => e.id === id);
        if (!experiment) return null;

        // Returner en samlet pakke med eksperiment-definitionen og de tilhørende argumenter
        return {
          definition: experiment,
          args: args // Bevares som et array af strenge
        };
      })
      .filter((item) => item !== null); //.filter(Boolean);

    // 2. Find ud af, hvilke kategorier der er blevet "kapret" af et eksklusivt eksperiment
    // Map'et holder styr på: Kategori -> Eksklusivt Eksperiment ID
    /** @type {Map<string, string>} */
    const typeWinners = new Map();

    requestedExperiments.forEach(item => {
      const experiment = item.definition;
      if (experiment.exclusive && experiment.type) {
        if (!typeWinners.has(experiment.type)) {
          typeWinners.set(experiment.type, experiment.id);
          console.log(`[Eksperiment] '${experiment.id}' har eksklusivt låst kategorien '${experiment.type}'.`);
        }
      }
    });

    // 3. Initialiser eksperimenterne med striks håndhævelse af eksklusivitet
    requestedExperiments.forEach(item => {
      const experiment = item.definition;
      const type = experiment.type;

      // --- TJEK 1: GENSIDIG UDELUKKELSE (EXCLUSIVE) ---
      if (type && typeWinners.has(type)) {
        const winnerId = typeWinners.get(type);
        if (experiment.id !== winnerId) {
          console.warn(`[Eksperiment] '${experiment.id}' blev udelukket. Det eksklusive modul '${winnerId}' har spærret kategorien '${type}'.`);
          return; 
        }
      }

      // --- TJEK 2: FORHINDRE DUBLETTER (DEDUPING) ---
      if (appState.activeExperiments.has(experiment.id) && !experiment.allowMultiple) {
        console.warn(`[Eksperiment] '${experiment.id}' kører allerede og blev ignoreret for at undgå dublering.`);
        return;
      }

      // --- INITIALISERING ---
      // Eksekver init-metoden og videresend argumenterne (f.eks. ['full'] eller ['20'])
      experiment.init(appState, item.args);
      
      // Registrer eksperimentet som aktivt i staten
      appState.activeExperiments.add(experiment.id);
    });
  }
};